/**
 * Eric tool-bucket permissions — client types + helpers.
 *
 * Mirrors `worker/lib/eric-permissions.ts`. The wire shape is a
 * fully-populated object after the server resolver fills in defaults,
 * so client code can index without null checks.
 */

export type EricPermissions = {
  customers: { read: boolean; write: boolean }
  vehicles: { read: boolean; write: boolean }
  appointments: { read: boolean; write: boolean }
  estimates: { read: boolean; write: boolean }
  calls: { read: boolean }
}

export const DEFAULT_PERMISSIONS: EricPermissions = {
  customers: { read: true, write: true },
  vehicles: { read: true, write: true },
  appointments: { read: true, write: true },
  estimates: { read: true, write: true },
  calls: { read: true },
}

export type BucketKey = keyof EricPermissions
export type ModeKey = 'read' | 'write'

// Order matches the server `PERMISSION_BUCKETS`. Customers / Vehicles /
// Appointments first because they're the trio Emil leans on day-to-day;
// Estimates + Calls below since they're advisory rather than write-
// heavy on the v0.2 surface.
export const BUCKET_ORDER: ReadonlyArray<{
  key: BucketKey
  modes: ReadonlyArray<ModeKey>
}> = [
  { key: 'customers', modes: ['read', 'write'] },
  { key: 'vehicles', modes: ['read', 'write'] },
  { key: 'appointments', modes: ['read', 'write'] },
  { key: 'estimates', modes: ['read', 'write'] },
  { key: 'calls', modes: ['read'] },
]
